import {
    FlagsData,
    notifyLoginLogoutDTO,
    subscribeData,
    subscribeMobileDeviceDTO,
    unsubscribeData,
    unsubscribeMobileDeviceDTO,
    updateData,
} from '.';
import {
    HEALTH_CHECK,
    IChangeFeatureFlags,
    IMainPageChanged,
    INeedNotifyLogin,
    INotifyLoginLogoutFailure,
    INotifyLoginLogoutRequest,
    INotifyLoginLogoutSuccess,
    IOrganizationServiceStatus,
    IRESubscribeNotification,
    IRESubscribeNotificationFailure,
    IRESubscribeNotificationSuccess,
    IResidentsServiceStatus,
    ISaveDeviceInfo,
    ISetUserMobileDeviceAsTag,
    ISocketsNOTWorking,
    ISocketsWorking,
    ISubscribeNotification,
    ISubscribeNotificationFailure,
    ISubscribeNotificationForbidden,
    ISubscribeNotificationSuccess,
    ISubscribeUserMobileDeviceFailure,
    ISubscribeUserMobileDeviceRequest,
    ISubscribeUserMobileDeviceSuccess,
    IUnSubscribeNotification,
    IUnSubscribeNotificationFailure,
    IUnSubscribeNotificationSuccess,
    IUnSubscribeUserMobileDeviceFailure,
    IUnSubscribeUserMobileDeviceRequest,
    IUnSubscribeUserMobileDeviceSuccess,
} from './types';

export function subscribeNotif(payload: subscribeData): ISubscribeNotification {
    return { type: HEALTH_CHECK.SUBSCRIBE_NOTIFICATION_REQUEST, payload };
}

export function subscribeNotifSuccess(payload: subscribeData): ISubscribeNotificationSuccess {
    return { type: HEALTH_CHECK.SUBSCRIBE_NOTIFICATION_SUCCESS, payload };
}

export function subscribeNotifFailure(payload: subscribeData): ISubscribeNotificationFailure {
    return { type: HEALTH_CHECK.SUBSCRIBE_NOTIFICATION_FAILURE, payload };
}
export function subscribeNotifForbidden(deviceId: string): ISubscribeNotificationForbidden {
    return { type: HEALTH_CHECK.SUBSCRIBE_NOTIFICATION_FORBIDDEN, payload: deviceId };
}

export function unsubscribeNotif(payload: unsubscribeData): IUnSubscribeNotification {
    return { type: HEALTH_CHECK.UN_SUBSCRIBE_NOTIFICATION_REQUEST, payload };
}

export function unsubscribeNotifSuccess(payload: unsubscribeData): IUnSubscribeNotificationSuccess {
    return { type: HEALTH_CHECK.UN_SUBSCRIBE_NOTIFICATION_SUCCESS, payload };
}

export function unsubscribeNotifFailure(payload: unsubscribeData): IUnSubscribeNotificationFailure {
    return { type: HEALTH_CHECK.UN_SUBSCRIBE_NOTIFICATION_FAILURE, payload };
}

export function updateSubscribeNotif(payload: updateData): IRESubscribeNotification {
    return { type: HEALTH_CHECK.RE_SUBSCRIBE_NOTIFICATION_REQUEST, payload };
}

export function updateSubscribeNotifSuccess(payload: updateData): IRESubscribeNotificationSuccess {
    return { type: HEALTH_CHECK.RE_SUBSCRIBE_NOTIFICATION_SUCCESS, payload };
}

export function updateSubscribeNotifFailure(payload: unsubscribeData): IRESubscribeNotificationFailure {
    return { type: HEALTH_CHECK.RE_SUBSCRIBE_NOTIFICATION_FAILURE, payload };
}

export function saveDevicePNInfo(value: subscribeData): ISaveDeviceInfo {
    return { type: HEALTH_CHECK.SAVE_PNS_MOBILE_ID, payload: value };
}

export function notifyLoginLogout(isLogin: boolean, value: notifyLoginLogoutDTO): INotifyLoginLogoutRequest {
    return {
        type: HEALTH_CHECK.NOTIFY_LOGIN_LOGOUT_REQUEST,
        payload: { isLogin, value },
    };
}
export function notifyLoginLogoutSuccess(isLogin: boolean): INotifyLoginLogoutSuccess {
    return { type: HEALTH_CHECK.NOTIFY_LOGIN_LOGOUT_SUCCESS, payload: isLogin };
}
export function notifyLoginLogoutFailure(value: any): INotifyLoginLogoutFailure {
    return { type: HEALTH_CHECK.NOTIFY_LOGIN_LOGOUT_FAILURE, payload: value };
}

export function socketsWorking(): ISocketsWorking {
    return { type: HEALTH_CHECK.SOCKETS_WORKING, payload: undefined };
}

export function socketsNotWorking(value: any): ISocketsNOTWorking {
    return { type: HEALTH_CHECK.SOCKETS_NOT_WORKING, payload: value };
}

export function organizationServiceStatusChange(isAlive: boolean): IOrganizationServiceStatus {
    return { type: HEALTH_CHECK.ORGANIZATION_SERVICE_STATUS, isAlive };
}

export function residentsServiceStatusChange(isAlive: boolean): IResidentsServiceStatus {
    return { type: HEALTH_CHECK.RESIDENTS_SERVICE_STATUS, isAlive };
}

export function changeFeatureFlags(value: FlagsData): IChangeFeatureFlags {
    return { type: HEALTH_CHECK.ON_CHANGE_FEATURE_FLAGS, payload: value };
}

export function needToNotifyLogin(): INeedNotifyLogin {
    return { type: HEALTH_CHECK.NEED_TO_NOTIFY_LOGIN };
}
export function mainPageChanged(value: boolean): IMainPageChanged {
    return { type: HEALTH_CHECK.MAIN_PAGE_CHANGED, payload: value };
}

export function subscribeUserMobileDeviceAsTag(payload: subscribeMobileDeviceDTO): ISubscribeUserMobileDeviceRequest {
    return { type: HEALTH_CHECK.SUBSCRIBE_USER_MOBILE_DEVICE_REQUEST, payload };
}

export function subscribeUserMobileDeviceAsTagSuccess(
    payload: subscribeMobileDeviceDTO,
): ISubscribeUserMobileDeviceSuccess {
    return { type: HEALTH_CHECK.SUBSCRIBE_USER_MOBILE_DEVICE_SUCCESS, payload };
}

export function subscribeUserMobileDeviceAsTagFailure(payload: any): ISubscribeUserMobileDeviceFailure {
    return { type: HEALTH_CHECK.SUBSCRIBE_USER_MOBILE_DEVICE_FAILURE, payload };
}

export function unsubscribeUserMobileDeviceAsTag(
    payload: unsubscribeMobileDeviceDTO,
): IUnSubscribeUserMobileDeviceRequest {
    return { type: HEALTH_CHECK.UNSUBSCRIBE_USER_MOBILE_DEVICE_REQUEST, payload };
}

export function unsubscribeUserMobileDeviceAsTagSuccess(
    payload: unsubscribeMobileDeviceDTO,
): IUnSubscribeUserMobileDeviceSuccess {
    return { type: HEALTH_CHECK.UNSUBSCRIBE_USER_MOBILE_DEVICE_SUCCESS, payload };
}

export function unsubscribeUserMobileDeviceAsTagFailure(payload: any): IUnSubscribeUserMobileDeviceFailure {
    return { type: HEALTH_CHECK.UNSUBSCRIBE_USER_MOBILE_DEVICE_FAILURE, payload };
}

export function setUserMobileDeviceAsTag(): ISetUserMobileDeviceAsTag {
    return { type: HEALTH_CHECK.SET_THIS_MOBILE_DEVICE_AS_TAG };
}
